/**
 * Footer Component - MAX AET Design
 * Application footer with branding
 */

import React from "react";
import type { Language } from "../types";

interface FooterProps {
  language: Language;
}

const Footer: React.FC<FooterProps> = ({ language }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <p className="footer-text">
        MAX AET SYSTEM v3.0 // Powered by <span className="footer-highlight">AET AI Academy</span> // {currentYear}
      </p>
    </footer>
  );
};

export default Footer;
